// Auto-generated by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated on every build/deploy. Gitignored.
const BUILD_INFO = {
  "sha": "998a6fc8fb14737fbcc52f38fc8c8b2936e97a29",
  "shaShort": "998a6fc",
  "branch": "main",
  "time": "2026-11-04T18:40:04.729Z"
};

module.exports = BUILD_INFO;
module.exports.default = BUILD_INFO;
